import { useEffect, useSyncExternalStore } from 'react'
import { telemetryStore } from './store'
import type { TelemetryState } from './core'

export function useTelemetry(): TelemetryState {
  return useSyncExternalStore(telemetryStore.subscribe, telemetryStore.getState)
}

/** Mounted once in the shell: boots the consolidated feed subscriptions. */
export function TelemetryBoot() {
  useEffect(() => {
    telemetryStore.start()
  }, [])
  return null
}
